import { api } from '@/services/api/main/axios';
import config from '@/config';

export interface RegisterForm {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  promoCode?: string;
  recaptchaResponse: string;
  trackingId?: string;
  referredBy?: string;
  language: string;
  site_id?: string;
}

export const registerApiRequest = async (form: RegisterForm) => {
  return api.post('auth/register', {
    ...form,
    site_id: config.api.site_id,
  });
};

export const resendVerificationEmailApiRequest = async () => {
  return api.post('auth/resend-activation-email');
};

export const validateFieldApiRequest = async (
  entity: string,
  validation: string,
  value: string,
) => {
  return api.post<{ isValid: boolean }>(`/${entity}/validation/${validation}`, { value });
};
